import { cn } from "../..";

import type { CSSProperties } from "react";

interface Props extends React.ComponentProps<"span"> {
  component: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const nonStandardStyles: CSSProperties = { textRendering: "optimizeLegibility" };

export const Icon = (props: Props) => {
  const { component: Component, className, ...spanProps } = props;

  return (
    <span
      {...spanProps}
      style={nonStandardStyles}
      className={cn(
        className,
        "text-inherit box-border inline-block items-center text-center align-[-0.125em] normal-case not-italic leading-[0] antialiased"
      )}
    >
      <Component />
    </span>
  );
};

Icon.displayName = "Icon";
